import React, { Component } from 'react';
import { Flex, Card, Heading, Subhead, ButtonTransparent, Small } from 'rebass';
import styled from 'styled-components';
import { colors, shadows } from '../theme';
import Text from './Text';

const CheckoutOption = styled(Card)`
  /* cursor: pointer; */
  text-align: left;
  line-height: 1.5;
  text-align: center;
  box-shadow: ${shadows.small};
  padding: 0px;

  &:hover {
    box-shadow: ${shadows.medium};
  }

  &:focus {
    box-shadow: ${shadows.outline};
  }
`;

class CheckoutSelect extends Component {
  state = {
    option: '',
  };

  setOption = option => {
    this.setState({
      option,
    });
    this.props.updatePlan(option);
  };

  render() {
    return (
      <div>
        <Flex justifyContent="center">
          <ButtonTransparent onClick={() => this.setOption('1')}>
            <CheckoutOption
              width="200px"
              bg={this.state.option == 1 ? 'gray2' : 'white'}
            >
              <Text pt={3}>Monthly</Text>
              <Text fontSize="14px" fontWeight="300">
                $15/month
              </Text>
              <Text color="gray6" fontSize="12px" fontWeight="300" pb={3}>
                Billed monthly
              </Text>
            </CheckoutOption>
          </ButtonTransparent>
          <ButtonTransparent onClick={() => this.setOption('2')}>
            <CheckoutOption
              width="200px"
              bg={this.state.option == 2 ? 'gray2' : 'white'}
            >
              <Text pt={3}>Yearly</Text>
              <Text fontSize="14px" fontWeight="300">
                $7/month
              </Text>
              <Text color="gray6" fontSize="12px" fontWeight="300" pb={3}>
                Billed $84 yearly
              </Text>
            </CheckoutOption>
          </ButtonTransparent>
          <ButtonTransparent onClick={() => this.setOption('3')}>
            <CheckoutOption
              width="200px"
              bg={this.state.option == 3 ? 'gray2' : 'white'}
            >
              <Text pt={3}>Lifetime</Text>
              <Text fontSize="14px" fontWeight="300">
                $160
              </Text>
              <Text color="gray6" fontSize="12px" fontWeight="300" pb={3}>
                Billed once
              </Text>
            </CheckoutOption>
          </ButtonTransparent>
        </Flex>
      </div>
    );
  }
}

export default CheckoutSelect;
